<template>
  <v-container>
    <div class="title-icon">
      <h1>{{ $t('ebook.report-overview')}}</h1>
      <v-btn icon :href="links.ebook.apprenticeInfo">
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>
    <!-- <p>
      <ActionButton
        class="smallerText"
        actionIcon="$sl-eye"
        :disabled="false" 
        @click="$nextTick(()=>{$router.push({name: 'EbookReportNew', params: {id: Number($route.params.id), reportId: -1} })})"
      >{{$t('ebook.create-new-report')}}</ActionButton>
    </p> -->
    <template>
      <ReportsList @reportDetailItem="reportDetailItem" :bookId="Number($route.params.id)" />
    </template>

    <!-- <BottomNav
      class="mt-5"
      @clicked="$nextTick(()=>{$router.push({name: 'EbookStart', params: {id: $route.params.id} })})"
    /> -->
    <v-btn fixed fab bottom right        
      class="elevation"
      color="primary"
      @click="$nextTick(()=>{$router.push({name: 'EbookReportNew', params: {id: Number($route.params.id), reportId: -1, returnUrl: 'EbookReportOverviewStart'} })})"
      :disabled="!bookActive"
    >
      <v-icon>$sl-add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import API from '@/services/api.js'
import BottomNav from '@/components/Application/BottomNav'
import ActionButton from '@/components/Common/ActionButton'
import ReportsList from '@/components/Ebook/Reports/ReportsList'

// @group Ebook
// Styled ReportOverviewStart component
export default {
  name: 'ReportOverviewStart',

  components: {
    BottomNav,
    ActionButton,
    ReportsList
  },

  data: () => ({
    links: require('../../lib/external-links.json'),
    show: 'instructor',
    currentReport: {}
  }),
  methods: {
    reportDetailItem(item) {      
      this.$nextTick(() => {
        this.$router.push({
          name: 'EbookReportNew',
          params: {bookId: item.bookId, reportId: item.id}
        })
      })
    }
  },
  created() {    
    if (!(this.$route.params.id || this.currentUser)) {
      this.$router.push('/').catch(() => {});
    }

    this.currentReport = {}
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isInstructor']),

    bookActive(){
      if(this.currentUser && this.currentUser.books && this.currentUser.educations && this.$route.params.id){
        const book = this.currentUser.books.find(b => b.id==this.$route.params.id)
        return book && book.bookStatus.id === 2
      }
      return false
    }
  },
  
}
</script>

<style lang="scss">
.titleSection {
  display: flex;
  justify-content: space-between;
  align-items: center;
  p,
  h1,
  h2 {
    margin-bottom: 0;
  }
  margin-bottom: 0.5em;
}
.v-list-item__subtitle {
  font-size: 14px !important;
}
.v-list--three-line .v-list-item,
.v-list-item--three-line {
  min-height: 80px !important;
}
</style>
